import type { ISignableDocument } from '@/models/legal_documents'
import { SignableDocument } from '@/models/legal_documents'
import type { ILegalDocumentInitiateSigningData } from '@/services/legal_document/'
import legalDocumentService from '@/services/legal_document/legal-document'
import { defineStore } from 'pinia'
import type { ILegalDocumentState } from './legal-document.types'

export const useLegalDocumentStore = defineStore('legalDocument', {
  state: (): ILegalDocumentState => ({
    signableDocuments: []
  }),
  
  getters: {
    getSignableDocuments(state: ILegalDocumentState): ISignableDocument[] {
      return state.signableDocuments.map((document) => new SignableDocument(document))
    }
  },

  actions: {
    async fetchSignableDocuments() {
      const documents = await legalDocumentService.fetchSignableDocuments()
      this.signableDocuments = documents
    },

    async initiateDocumentSigning(data: ILegalDocumentInitiateSigningData) {
      await legalDocumentService.initiateDocumentSigning(data)
    }
  }
})
